import { gql } from '@apollo/client';
import { ID_NAME_FIELDS } from '../common';

export const PROJECT_LINK_FRAGMENT = gql`
  fragment projectLink on ProjectLink {
    id
    projectId
    projectType {
      ${ID_NAME_FIELDS}
    }
  }
`;
